@tailwind base;
@tailwind components;
@tailwind utilities;

:host {
  display: var(--ids-comp-icon-display);
}
